export default {
    COMMISSION_RULES_REQUEST: 'APP/COMMISSION_MANAGEMENT_RULES/COMMISSION_RULES_REQUEST',
    COMMISSION_RULES_SUCCESS: 'APP/COMMISSION_MANAGEMENT_RULES/COMMISSION_RULES_SUCCESS',
    COMMISSION_RULES_ERROR: 'APP/COMMISSION_MANAGEMENT_RULES/COMMISSION_RULES_ERROR',
  };